const key = (userId) => `favorites:${userId}`;
const EVENT = 'favoritesChanged';

const read = (userId) => {
  if (!userId) return [];
  try {
    const raw = localStorage.getItem(key(userId));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const write = (userId, list) => {
  if (!userId) return;
  localStorage.setItem(key(userId), JSON.stringify(list));
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { userId, list } }));
};

export const getFavorites = (userId) => read(userId);

export const isFavorite = (userId, providerId) =>
  !!providerId && read(userId).includes(providerId);

export const addFavorite = (userId, providerId) => {
  if (!userId || !providerId) return read(userId);
  const list = read(userId);
  if (!list.includes(providerId)) {
    list.push(providerId);
    write(userId, list);
  }
  return list;
};

export const removeFavorite = (userId, providerId) => {
  if (!userId || !providerId) return read(userId);
  const list = read(userId).filter((id) => id !== providerId);
  write(userId, list);
  return list;
};

export const toggleFavorite = (userId, providerId) =>
  isFavorite(userId, providerId)
    ? removeFavorite(userId, providerId)
    : addFavorite(userId, providerId);

export const FAVORITES_EVENT = EVENT;
